const INJECTION_TYPES = ['non', 'proportionalToSteam', 'proportionalToFeedwater', 'proportionalToMakeUp', 'proportionalToBlowdown', 'schedule', 'probeDriven', 'manual', 'time', 'other'];
const CYCLE_TYPES = ['daily', 'weekly', '28day', 'monthly'];
const DAYS_OF_WEEK = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const PREBLEED_UNIT = ['non', 'min', 'hour', 'conductivitySetPoint'];
const BLOWDOWNLOCKOUT_UNIT = ['min', 'hour'];
const PROBE_DRIVEN_TYPE = ['ph', 'orp', 'fluorescence', 'conductivité', 'corrosion', 'other'];
const MAXIMUM_PUMP_PRESSURE_UNIIT = ['non', 'psig', 'kpa'];
const RATING_UNIT = ['non', 'gal/day', 'gal/hour', 'l/hour'];
const CONTROLLER_FUNCTIONALITIES_TYPE = ['blowdown', 'conductivity', 'ph', 'temperature', 'orp', 'fluorometer', 'CorrosionMeter', 'internetConnection', 'other'];


export {
    INJECTION_TYPES,
    CYCLE_TYPES,
    DAYS_OF_WEEK,
    PREBLEED_UNIT,
    BLOWDOWNLOCKOUT_UNIT,
    PROBE_DRIVEN_TYPE,
    MAXIMUM_PUMP_PRESSURE_UNIIT,
    RATING_UNIT,
    CONTROLLER_FUNCTIONALITIES_TYPE,
};
